var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartFail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFDADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6L7.34919 6.23351L7.97384 13.6755C8.02379 14.2833 8.53168 14.7496 9.14141 14.7477H16.2175C16.7994 14.749 17.293 14.3209 17.3754 13.7449L17.9909 9.49103C18.0597 9.01557 17.7295 8.57449 17.2547 8.50573C17.2132 8.4999 7.56584 8.49665 7.56584 8.49665",
    stroke: "#B00020",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85677 16.9964C9.05202 16.9964 9.20964 17.1547 9.20964 17.3493C9.20964 17.5445 9.05202 17.7028 8.85677 17.7028C8.66153 17.7028 8.50391 17.5445 8.50391 17.3493C8.50391 17.1547 8.66153 16.9964 8.85677 16.9964Z",
    fill: "#130F26",
    stroke: "#B00020",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1737 16.9964C16.3689 16.9964 16.5272 17.1547 16.5272 17.3493C16.5272 17.5445 16.3689 17.7028 16.1737 17.7028C15.9784 17.7028 15.8208 17.5445 15.8208 17.3493C15.8208 17.1547 15.9784 16.9964 16.1737 16.9964Z",
    fill: "#130F26",
    stroke: "#B00020",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2981 10.0013L11.3013 12.9982",
    stroke: "#B00020",
    strokeWidth: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2992 13L11.2998 10",
    stroke: "#B00020",
    strokeWidth: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartFail);
export default __webpack_public_path__ + "static/media/cart-fail.c947cce5a55f64db8042523bd0c7ede1.svg";
export { ForwardRef as ReactComponent };